import { memo, useContext } from "react";
import { FLIGHT_TYPE, ITINERARY_INFO_TYPE } from "app/constants";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import classNames from "classnames";
import { FormattedDate } from "react-intl";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import PropTypes from "prop-types";

const TimelineInfoRecap = ({ event }) => {
	const { resolution } = useContext(AppGlobalsContext);

	const isMobile = resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL;
	const { type, data, flightType } = event;
	const scheduleClassName = classNames("itinerary-recap-timeline__schedule", {
		"itinerary-recap-timeline__schedule-arrival": flightType === FLIGHT_TYPE.ARRIVAL,
	});

	switch (type) {
		case ITINERARY_INFO_TYPE.SCHEDULE:
		case ITINERARY_INFO_TYPE.STOPOVER_SCHEDULE:
			return (
				<div className={scheduleClassName}>
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL}
						isBold
						className="itinerary-recap-timeline__schedule-airport"
					>
						{data.iata}
					</Typography>

					<div className="itinerary-recap-timeline__schedule-time">
						<Typography
							variant={TYPOGRAPHY_VARIANTS.SMALL}
							isBold
							className="take-off-time"
						>
							{data.time}
						</Typography>
					</div>
					<div className="itinerary-recap-timeline__schedule-date">
						<Typography
							variant={TYPOGRAPHY_VARIANTS.SMALL}
							className={classNames({
								"itinerary-recap-timeline__schedule-date--next-day":
									data.isNextDay ||
									(data.arrivalDaysCounter && data.arrivalDaysCounter > 0),
							})}
						>
							<FormattedDate
								timeZone="UTC"
								value={new Date(data.date)}
								weekday="short"
								day="2-digit"
								month="short"
							/>
						</Typography>
					</div>
				</div>
			);
		case ITINERARY_INFO_TYPE.FLIGHT_INFO:
			return (
				<div className="itinerary-recap-timeline__info">
					<div className="itinerary-recap-timeline__info-line" />
					{data?.stopCount > 0 && (
						<div className="itinerary-recap-timeline__info-leg-container">
							{data.legInfo && (
								<div className="itinerary-recap-timeline__info-leg">
									{data.legInfo}
								</div>
							)}
						</div>
					)}
				</div>
			);

		case ITINERARY_INFO_TYPE.STOPOVER_INFO:
			return (
				<div className="itinerary-recap-timeline__stop-over-info">
					{!isMobile && (
						<div className="itinerary-recap-timeline__stop-over-info--line" />
					)}
					<div className="itinerary-recap-timeline__stop-over-info--leg-container">
						{data.legInfo && (
							<div className="itinerary-recap-timeline__stop-over-info--leg">
								{data.legInfo}
							</div>
						)}
					</div>
				</div>
			);

		default:
			return null;
	}
};

TimelineInfoRecap.propTypes = {
	event: PropTypes.object,
};
export default memo(TimelineInfoRecap);
